import { render, staticRenderFns } from "./CtaCallAction.vue?vue&type=template&id=106ffb03&scoped=true&"
import script from "./CtaCallAction.vue?vue&type=script&lang=js&"
export * from "./CtaCallAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106ffb03",
  null
  
)

export default component.exports